import { tableAnatomy } from '@chakra-ui/anatomy';
import { createMultiStyleConfigHelpers } from '@chakra-ui/react';
import getThemes, { ThemesKeys } from './themeShared';

const style = createMultiStyleConfigHelpers(tableAnatomy.keys);

export const baseStyle = (theme: ThemesKeys) =>
  style.definePartsStyle(() => {
    return {
      thead: {
        tr: {
          th: {
            borderTop: '1px solid',
            borderBottom: '1px solid',
            borderColor: getThemes(theme).colors.palette.neutral[60],
            color: getThemes(theme).colors.palette.primary[0],
            px: 2,
            py: 4,
            div: {
              textTransform: 'none',
              fontWeight: '600',
            },
          },
        },
      },
      tbody: {
        tr: {
          td: {
            borderColor: getThemes(theme).colors.palette.neutral[60],
            px: 2,
            py: 4,
          },
        },
      },
    };
  });

export const sizes = (theme: ThemesKeys) => {
  return {
    xs: {
      tbody: {
        tr: {
          marginBottom: 1,
          borderColor: getThemes(theme).colors.palette.neutral[60],
          borderRadius: 4,
          td: {
            px: 3,
            py: 3,
            borderWidth: 0,
            h: 'full',
            w: 'full',
            alignItems: 'center',
            flexDirection: 'column',
          },
        },
      },
    },
  };
};

export const tableTheme = (theme: ThemesKeys) =>
  style.defineMultiStyleConfig({
    baseStyle: baseStyle(theme),
    sizes: sizes(theme),
  });

export default (theme: ThemesKeys) => tableTheme(theme);
